import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppSelector } from "Redux/hooks";
import { selectOrganizationById } from "feature/admin/slice";
import { useParams } from "react-router-dom";

export default function OrganizationBreadcrumbs() {
  const { orgId } = useParams();
  const organization = useAppSelector((state) =>
    selectOrganizationById(state, orgId || "")
  );
  return (
    <div>
      <div>
        <nav className="sm:hidden" aria-label="Back">
          <a
            href="#"
            className="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700"
          >
            <FontAwesomeIcon
              icon={faChevronLeft}
              className="-ml-1 mr-1 h-5 w-5 flex-shrink-0 text-gray-400"
              aria-hidden="true"
            />
            Back
          </a>
        </nav>
        <nav className="hidden sm:flex" aria-label="Breadcrumb">
          <ol role="list" className="flex items-center space-x-4">
            <li>
              <div className="flex">
                <p className="text-sm font-medium text-gray-500">
                  Organizations
                </p>
              </div>
            </li>
            <li>
              <div className="flex items-center">
                <FontAwesomeIcon
                  icon={faChevronRight}
                  className="h-5 w-5 flex-shrink-0 text-gray-400"
                  aria-hidden="true"
                />
                <a
                  href="#"
                  aria-current="page"
                  className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >
                  {organization?.name}
                </a>
              </div>
            </li>
          </ol>
        </nav>
      </div>
      <div className="mt-2 md:flex md:items-center md:justify-between">
        <div className="min-w-0 flex-1">
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
            {organization?.name}
          </h2>
        </div>
      </div>
    </div>
  );
}
